import {Component, isDevMode, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {environment} from "../../../../../environments/environment";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {Observable, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {MatSelectChange} from "@angular/material/select";
import * as XLSX from "xlsx";
import {Centre} from "../../../../interfaces/Centres";
import {CentreService} from "../../../../services/centre.service";
import {Timestamp} from "firebase/firestore";
import {PermissionType} from "../../../../components/employee/PermissionType.enum";
import {FinancialYearService} from "../../../../services/financial-year.service";

@Component({
  selector: 'app-allergy-type-report',
  templateUrl: './allergy-type-report.component.html',
  styleUrls: ['./allergy-type-report.component.scss']
})
export class AllergyTypeReportComponent implements OnInit, OnDestroy {
  env = isDevMode() ? environment.testMode : environment.productionMode;
  private _destroyed$ = new Subject<void>();
   allergies: any;
   childName: string = '';
   centreName: any;
  displayedColumns: string[] = ['childName', 'DoA','allergies', 'centreName'];
  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  centres$: Observable<Centre[]>;
  mStartDate: Date|null=null;
  mEndDate: Date|null=null ;
  selectedCentreCode: any = null
  selectedCentre:any;
  displayCentre = (c: any) => c?.centreName;
  fileName = 'Allergy_Type_Report.xlsx';

  constructor( private mFirestore: AngularFirestore ,
               private mCentreService: CentreService,
               private readonly financialYearService: FinancialYearService) {
    this.centres$ = this.mCentreService.getAllCentres();
  }

  ngOnInit(): void {
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.mStartDate = fy.startDate;
    this.mEndDate = fy.endDate;
    // this.mFirestore.collection(this.env.child,).valueChanges().subscribe((children: any[]) => {
    //   const filteredChildren = children
    //     .filter(child => child.allergies && !['undefined', 'none', 'no', 'na', ''].includes(child.allergies.toLowerCase()));
    //
    //   this.dataSource.data = filteredChildren.map(child => ({
    //     childName: `${child.firstName} ${child.lastName}`,
    //     allergies: child.allergies,
    //     centreName: child.centreName
    //   }));
    //   this.dataSource.paginator = this.paginator;
    //
    // });
  }


  onCentreSelect(selectedCentre: Centre) {
    if (!selectedCentre) return;

    console.log("Selected Centre:", selectedCentre);

    this.selectedCentre = selectedCentre;

    this.selectedCentreCode=selectedCentre.centreCode;

    // //  Set centre details in form
    // this.studentForm.patchValue({
    //   centreName: selectedCentre.centreName,
    //   centreCode: selectedCentre.centreCode
    // });
  }


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  OnCentreChange($event: MatSelectChange) {
    const centreSelected =$event.value
    this.mFirestore.collection(this.env.child).valueChanges().pipe(takeUntil(this._destroyed$)).subscribe((children: any[]) => {
      const filteredChildren = children
        .filter(child => child.allergies && !['undefined', 'none', 'no', 'na', ''].includes(child.allergies.toLowerCase()) && child.centreCode == centreSelected );

      this.dataSource.data = filteredChildren.map(child => ({
        childName: `${child.firstName} ${child.lastName}`,
        allergies: child.allergies,
        centreName: child.centreName,
        dateOfAdmission:child.dateOfAdmission

      }));
      this.dataSource.paginator = this.paginator;

    });
  }

  search() {

    this.dataSource.data = [];

    console.log(this.selectedCentreCode)
    console.log(this.mStartDate)
    console.log(this.mEndDate)
    if (this.mStartDate == null && this.mEndDate == null && this.selectedCentreCode == null) {
      this.mFirestore.collection(this.env.child,).valueChanges().pipe(takeUntil(this._destroyed$)).subscribe((children: any[]) => {
        const filteredChildren = children
          .filter(child => child.allergies && !['undefined', 'none', 'no', 'na', ''].includes(child.allergies.toLowerCase()) );
        this.dataSource.data = filteredChildren.map(child => ({
          childName: `${child.firstName} ${child.lastName}`,
          allergies: child.allergies,
          centreName: child.centreName,
          dateOfAdmission:child.dateOfAdmission

        }));
        this.dataSource.paginator = this.paginator;

      });

    }
    else if (this.mStartDate != null && this.mEndDate != null && this.selectedCentreCode == null) {
      this.mFirestore.collection(this.env.child, ref => ref.where('dateOfAdmission',
        '>=', this.mStartDate)
        .where('dateOfAdmission', '<=', this.mEndDate)).valueChanges().pipe(takeUntil(this._destroyed$)).subscribe((children: any[]) => {
        const filteredChildren = children
          .filter(child => child.allergies && !['undefined', 'none', 'no', 'na', ''].includes(child.allergies.toLowerCase()));

        this.dataSource.data = filteredChildren.map(child => ({
          childName: `${child.firstName} ${child.lastName}`,
          allergies: child.allergies,
          centreName: child.centreName,
          dateOfAdmission:child.dateOfAdmission
        }));
        this.dataSource.paginator = this.paginator;

      });
    }
   else if (this.mStartDate !== null && this.mEndDate != null && this.selectedCentreCode != null) {
      this.mFirestore.collection(this.env.child, ref => ref.where('dateOfAdmission',
        '>=', this.mStartDate)
        .where('dateOfAdmission', '<=', this.mEndDate)).valueChanges().pipe(takeUntil(this._destroyed$)).subscribe((children: any[]) => {
        const filteredChildren = children
          .filter(child => child.allergies && !['undefined', 'none', 'no', 'na', ''].includes(child.allergies.toLowerCase()) && child.centreCode == this.selectedCentreCode);
        console.log('in 3')
        console.log(children)
        this.dataSource.data = filteredChildren.map(child => ({
          childName: `${child.firstName} ${child.lastName}`,
          allergies: child.allergies,
          centreName: child.centreName,
          dateOfAdmission:child.dateOfAdmission

        }));
        this.dataSource.paginator = this.paginator;

      });


    }
   else if (this.mStartDate == null && this.mEndDate == null && this.selectedCentreCode != null) {
     this.mFirestore.collection(this.env.child, ref =>
       ref.where('centreCode','==',this.selectedCentreCode)
     ).valueChanges().pipe(takeUntil(this._destroyed$)).subscribe((children: any[]) => {
       console.log(children)
        const filteredChildren = children
          .filter(child => child.allergies && !['undefined', 'none', 'no', 'na', ''].includes(child.allergies.toLowerCase()))
        this.dataSource.data = filteredChildren.map(child => ({
          childName: `${child.firstName} ${child.lastName}`,
          allergies: child.allergies,
          centreName: child.centreName,
          dateOfAdmission:child.dateOfAdmission
        }));
        this.dataSource.paginator = this.paginator;

      });
    }
  }

  exportexcel() {
    let element = document.getElementById('excel-table');

    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    // const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
    // const ws: XLSX.WorkSheet =XLSX.utils.json_to_sheet(this.receipts)
    ws['!cols'] = [];
    ws['!cols'][19] = {hidden: true};

    /* O1 is your Column in Excel*/

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, this.fileName);

  }

  Clear() {
    this.selectedCentreCode = null
    this.selectedCentre=null
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.mStartDate = fy.startDate;
    this.mEndDate = fy.endDate;
    this.dataSource = new MatTableDataSource<any>();
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  protected readonly PermissionType = PermissionType;

}
